import Vue from "vue";
import Vuex from "vuex";

import { ApplicationModule as ApplicationModuleLocal } from "./application";
import { RoutesModule as RoutesModuleLocal } from "./routes";
import { SessionModule as SessionModuleLocal } from "./session";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  modules: {
    application: ApplicationModuleLocal,
    routes: RoutesModuleLocal,
    session: SessionModuleLocal,
  },
});

export { ApplicationModule } from "./application";
export { RoutesModule } from "./routes";
export { SessionModule } from "./session";
export { getModule as getStoreModule } from "vuex-module-decorators";
